
import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';
import { useComercialContext } from '../../comercial/ComercialContext';

export const useCartPromotions = () => {
    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { actingAsCliente } = useComercialContext();

    useEffect(() => {
        const fetchPromotions = async () => {
            setLoading(true);
            try {
                const url = `cart-promotions/active`;
                const headers = actingAsCliente?.numCliente
                    ? { 'X-Acting-As-Client': actingAsCliente.numCliente }
                    : {};
                const response = await ApiClient.performRequest(url, { headers });
                console.log("[DEBUG] CartPromotions response:", response);
                setPromotions(response);
            } catch (err) {
                console.error("[DEBUG] Error fetching promotions", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPromotions();
    }, [actingAsCliente]);

    return { promotions, loading, error };
};
